// Import Images
import product1 from "../../assets/images/products/img-1.png";
import product2 from "../../assets/images/products/img-2.png";
import product3 from "../../assets/images/products/img-3.png";
import product4 from "../../assets/images/products/img-4.png";
import product5 from "../../assets/images/products/img-5.png";

import company1 from "../../assets/images/companies/img-1.png";
import company2 from "../../assets/images/companies/img-2.png";
import company3 from "../../assets/images/companies/img-3.png";
import company5 from "../../assets/images/companies/img-5.png";
import company8 from "../../assets/images/companies/img-8.png";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";

// Define the widgets data
const kEcomWidgets = [
    {
        id: 1,
        cardColor: "primary",
        label: "Total Earnings",
        badge: "ri-arrow-right-up-line",
        badgeClass: "success",
        percentage: "+16.24",
        counter: "559.25",
        link: "View net earnings",
        bgcolor: "success",
        icon: "bx bx-dollar-circle",
        decimals: 2,
        prefix: "$",
        suffix: "k"
    },
    {
        id: 2,
        cardColor: "secondary",
        label: "Orders",
        badge: "ri-arrow-right-down-line",
        badgeClass: "danger",
        percentage: "-3.57",
        counter: "36894",
        link: "View all orders",
        bgcolor: "info",
        icon: "bx bx-shopping-bag",
        decimals: 0,
        prefix: "",
        separator: ",",
        suffix: ""
    },
    {
        id: 3,
        cardColor: "success",
        label: "Customers",
        badge: "ri-arrow-right-up-line",
        badgeClass: "success",
        percentage: "+29.08",
        counter: "183.35",
        link: "See details",
        bgcolor: "warning",
        icon: "bx bx-user-circle",
        decimals: 2,
        prefix: "",
        suffix: "M"
    },
    {
        id: 4,
        cardColor: "info",
        label: "My Balance",
        badgeClass: "muted",
        percentage: "+0.00",
        counter: "165.89",
        link: "Withdraw money",
        bgcolor: "primary",
        icon: "bx bx-wallet",
        decimals: 2,
        prefix: "$",
        suffix: "k"
    },
];

const kBestSellingProducts = [
    {
        id: 1,
        img: product1,
        label: "Branded T-Shirts",
        date: "24 Apr 2021",
        price: "29.00",
        orders: 62,
        stock: 510,
        amount: 1798,
    },
    {
        id: 2,
        img: product2,
        label: "Bentwood Chair",
        date: "19 Mar 2021",
        price: "85.20",
        orders: 35,
        amount: 2982,
    },
    {
        id: 3,
        img: product3,
        label: "Borosil Paper Cup",
        date: "01 Mar 2021",
        price: "14.00",
        orders: 80,
        stock: 749,
        amount: 1120,
    },
    {
        id: 4,
        img: product4,
        label: "One Seater Sofa",
        date: "11 Feb 2021",
        price: "127.50",
        orders: 56,
        amount: 7140,
    },
    {
        id: 5,
        img: product5,
        label: "Stillbird Helmet",
        date: "17 Jan 2021",
        price: "54",
        orders: 74,
        stock: 805,
        amount: 3996,
    },
];

const kTopSellers = [
    {
        id: 1,
        img: company1,
        label: "iTest Factory",
        name: "Oliver Tyler",
        product: "Bags and Wallets",
        stock: 8547,
        amount: 541200,
        percentage: 32,
    },
    {
        id: 2,
        img: company2,
        label: "Digitech Galaxy",
        name: "John Roberts",
        product: "Watches",
        stock: 895,
        amount: 75030,
        percentage: 79,
    },
    {
        id: 3,
        img: company3,
        label: "Nesta Technologies",
        name: "Harley Fuller",
        product: "Bike Accessories",
        stock: 3470,
        amount: 45600,
        percentage: 90,
    },
    {
        id: 4,
        img: company8,
        label: "Zoetic Fashion",
        name: "James Bowen",
        product: "Clothes",
        stock: 5488,
        amount: 29456,
        percentage: 40,
    },
    {
        id: 5,
        img: company5,
        label: "Meta4Systems",
        name: "Zoe Dennis",
        product: "Furniture",
        stock: 4100,
        amount: 11260,
        percentage: 57,
    },
];

const kRecentOrders = [
    {
        id: 1,
        orderId: "#VZ2112",
        img: avatar1,
        name: "Alex Smith",
        product: "Clothes",
        amount: "109.00",
        vendor: "Zoetic Fashion",
        status: "Paid",
        statusClass: "success",
        rating: "5.0",
        votes: "61",
    },
    {
        id: 2,
        orderId: "#VZ2111",
        img: avatar2,
        name: "Jansh Brown",
        product: "Kitchen Storage",
        amount: "149.00",
        vendor: "Micro Design",
        status: "Pending",
        statusClass: "warning",
        rating: 4.5,
        votes: "61",
    },
    {
        id: 3,
        orderId: "#VZ2109",
        img: avatar3,
        name: "Ayaan Bowen",
        product: "Bike Accessories",
        amount: "215.00",
        vendor: "Nesta Technologies",
        status: "Paid",
        statusClass: "success",
        rating: 4.9,
        votes: "89",
    },
    {
        id: 4,
        orderId: "#VZ2108",
        img: avatar4,
        name: "Prezy Mark",
        product: "Furniture",
        amount: "199.00",
        vendor: "Syntyce Solutions",
        status: "Unpaid",
        statusClass: "danger",
        rating: 4.3,
        votes: "47",
    },
    {
        id: 5,
        orderId: "#VZ2107",
        img: avatar6,
        name: "Vihan Hudda",
        product: "Bags and Wallets",
        amount: "330.00",
        vendor: "iTest Factory",
        status: "Paid",
        statusClass: "success",
        rating: 4.7,
        votes: "161",
    },
];

const kTopCategories = [
    {
        id: 1,
        category: "Mobile & Accessories",
        total: "10,294",
    },
    {
        id: 2,
        category: "Desktop",
        total: "6,256",
    },
    {
        id: 3,
        category: "Electronics",
        total: "3,479",
    },
    {
        id: 4,
        category: "Home & Furniture",
        total: "2,275",
    },
    {
        id: 5,
        category: "Grocery",
        total: "1,950",
    },
    {
        id: 6,
        category: "Fashion",
        total: "1,582",
    },
    {
        id: 7,
        category: "Appliances",
        total: "1,037",
    },
    {
        id: 8,
        category: "Beauty, Toys & More",
        total: "924",
    },
    {
        id: 9,
        category: "Food & Drinks",
        total: "701",
    },
    {
        id: 10,
        category: "Toys & Games",
        total: "239",
    },
];

// Revenue Chart Data
const kAllRevenueData = [
    {
        name: "Orders",
        type: "area",
        data: [34, 65, 46, 68, 49, 61, 42, 44, 78, 52, 63, 67],
    },
    {
        name: "Earnings",
        type: "bar",
        data: [
            89.25, 98.58, 68.74, 108.87, 77.54, 84.03, 51.24, 28.57, 92.57, 42.36,
            88.51, 36.57,
        ],
    },
    {
        name: "Refunds",
        type: "line",
        data: [8, 12, 7, 17, 21, 11, 5, 9, 7, 29, 12, 35],
    },
];

const kMonthRevenueData = [
    {
        name: "Orders",
        type: "area",
        data: [54, 85, 66, 18, 29, 31, 12, 14, 38, 72, 33, 27],
    },
    {
        name: "Earnings",
        type: "bar",
        data: [
            89.25, 98.58, 68.74, 108.87, 77.54, 84.03, 51.24, 28.57, 92.57, 42.36,
            88.51, 36.57,
        ],
    },
    {
        name: "Refunds",
        type: "line",
        data: [18, 22, 27, 37, 41, 21, 15, 19, 27, 19, 22, 45],
    },
];

const kHalfYearRevenueData = [
    {
        name: "Orders",
        type: "area",
        data: [34, 65, 46, 68, 49, 61, 42, 44, 78, 52, 63, 67],
    },
    {
        name: "Earnings",
        type: "bar",
        data: [
            89.25, 98.58, 68.74, 108.87, 77.54, 84.03, 51.24, 28.57, 92.57, 42.36,
            88.51, 36.57,
        ],
    },
    {
        name: "Refunds",
        type: "line",
        data: [8, 22, 87, 47, 41, 31, 5, 9, 47, 49, 32, 55],
    },
];

const kYearRevenueData = [
    {
        name: "Orders",
        type: "area",
        data: [14, 35, 26, 38, 29, 31, 22, 24, 58, 32, 33, 77],
    },
    {
        name: "Earnings",
        type: "bar",
        data: [
            99.25, 88.58, 78.74, 118.87, 87.54, 94.03, 61.24, 58.57, 102.57, 62.36,
            48.51, 66.57,
        ],
    },
    {
        name: "Refunds",
        type: "line",
        data: [58, 42, 47, 57, 71, 21, 15, 69, 17, 39, 52, 55],
    },
];

// Add this function at the top with other helper functions
function generateData(count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
        var x = (i + 1).toString() + "h";
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

        series.push({
            x: x,
            y: y
        });
        i++;
    }
    return series;
}

// Sample data for each time period
const kTodayAudiencesCountryData = [
    {
        name: "United States",
        data: [
            { x: "1h", y: 42 },
            { x: "2h", y: 58 },
            { x: "3h", y: 35 },
            { x: "4h", y: 62 },
            { x: "5h", y: 38 },
            { x: "6h", y: 72 },
            { x: "7h", y: 46 },
            { x: "8h", y: 55 },
            { x: "9h", y: 78 },
            { x: "10h", y: 45 },
            { x: "11h", y: 65 },
            { x: "12h", y: 50 }
        ]
    },
    {
        name: "India",
        data: [
            { x: "1h", y: 35 },
            { x: "2h", y: 42 },
            { x: "3h", y: 28 },
            { x: "4h", y: 47 },
            { x: "5h", y: 33 },
            { x: "6h", y: 58 },
            { x: "7h", y: 38 },
            { x: "8h", y: 42 },
            { x: "9h", y: 65 },
            { x: "10h", y: 38 },
            { x: "11h", y: 52 },
            { x: "12h", y: 45 }
        ]
    }
];

const kLastWeekAudiencesCountryData = [
    {
        name: "United States",
        data: [
            { x: "1h", y: 62 },
            { x: "2h", y: 78 },
            { x: "3h", y: 55 },
            { x: "4h", y: 82 },
            { x: "5h", y: 58 },
            { x: "6h", y: 92 },
            { x: "7h", y: 66 },
            { x: "8h", y: 75 },
            { x: "9h", y: 88 },
            { x: "10h", y: 65 },
            { x: "11h", y: 85 },
            { x: "12h", y: 70 }
        ]
    },
    {
        name: "India",
        data: [
            { x: "1h", y: 55 },
            { x: "2h", y: 62 },
            { x: "3h", y: 48 },
            { x: "4h", y: 67 },
            { x: "5h", y: 53 },
            { x: "6h", y: 78 },
            { x: "7h", y: 58 },
            { x: "8h", y: 62 },
            { x: "9h", y: 85 },
            { x: "10h", y: 58 },
            { x: "11h", y: 72 },
            { x: "12h", y: 65 }
        ]
    }
];

const kLastMonthAudiencesCountryData = [
    {
        name: "United States",
        data: [
            { x: "1h", y: 22 },
            { x: "2h", y: 28 },
            { x: "3h", y: 15 },
            { x: "4h", y: 22 },
            { x: "5h", y: 18 },
            { x: "6h", y: 28 },
            { x: "7h", y: 20 },
            { x: "8h", y: 25 },
            { x: "9h", y: 28 },
            { x: "10h", y: 15 },
            { x: "11h", y: 25 },
            { x: "12h", y: 20 }
        ]
    },
    {
        name: "India",
        data: [
            { x: "1h", y: 15 },
            { x: "2h", y: 22 },
            { x: "3h", y: 18 },
            { x: "4h", y: 27 },
            { x: "5h", y: 13 },
            { x: "6h", y: 28 },
            { x: "7h", y: 18 },
            { x: "8h", y: 22 },
            { x: "9h", y: 25 },
            { x: "10h", y: 18 },
            { x: "11h", y: 22 },
            { x: "12h", y: 25 }
        ]
    }
];

const kCurrentYearAudiencesCountryData = [
    {
        name: "United States",
        data: [
            { x: "1h", y: 52 },
            { x: "2h", y: 58 },
            { x: "3h", y: 45 },
            { x: "4h", y: 52 },
            { x: "5h", y: 48 },
            { x: "6h", y: 58 },
            { x: "7h", y: 50 },
            { x: "8h", y: 55 },
            { x: "9h", y: 58 },
            { x: "10h", y: 45 },
            { x: "11h", y: 55 },
            { x: "12h", y: 50 }
        ]
    },
    {
        name: "India",
        data: [
            { x: "1h", y: 45 },
            { x: "2h", y: 52 },
            { x: "3h", y: 48 },
            { x: "4h", y: 57 },
            { x: "5h", y: 43 },
            { x: "6h", y: 58 },
            { x: "7h", y: 48 },
            { x: "8h", y: 52 },
            { x: "9h", y: 55 },
            { x: "10h", y: 48 },
            { x: "11h", y: 52 },
            { x: "12h", y: 55 }
        ]
    }
];

// Store Visits by Source data
const kStoreVisitsData = [
    {
        name: "Direct",
        data: [10, 36, 12, 44, 33, 24, 54, 43, 63, 29, 41, 38]
    },
    {
        name: "Organic",
        data: [52, 43, 35, 27, 43, 64, 52, 41, 48, 53, 39, 42]
    },
    {
        name: "Referral",
        data: [22, 31, 36, 26, 47, 56, 42, 64, 43, 45, 53, 58]
    },
    {
        name: "Campaign",
        data: [26, 43, 48, 53, 33, 44, 56, 52, 34, 47, 54, 45]
    }
];

// Export all the constants
export {
    kEcomWidgets,
    kBestSellingProducts,
    kTopSellers,
    kRecentOrders,
    kTopCategories,
    kAllRevenueData,
    kMonthRevenueData,
    kHalfYearRevenueData,
    kYearRevenueData,
    kTodayAudiencesCountryData,
    kLastWeekAudiencesCountryData,
    kLastMonthAudiencesCountryData,
    kCurrentYearAudiencesCountryData,
    kStoreVisitsData
};